import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import AdminRoute from '../components/feature/AdminRoute';

const HomePage = lazy(() => import('../pages/home/page'));
const PricingPage = lazy(() => import('../pages/pricing/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const SignupPage = lazy(() => import('../pages/signup/page'));
const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const TemplatesPage = lazy(() => import('../pages/templates/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const AdminDashboardPage = lazy(() => import('../pages/admin/dashboard/page'));
const AdminUsersPage = lazy(() => import('../pages/admin/users/page'));
const AdminSubscriptionsPage = lazy(() => import('../pages/admin/subscriptions/page'));
const AdminToolsPage = lazy(() => import('../pages/admin/tools/page'));
const AdminAIUsagePage = lazy(() => import('../pages/admin/ai-usage/page'));
const AdminConversionsPage = lazy(() => import('../pages/admin/conversions/page'));
const AdminTemplatesPage = lazy(() => import('../pages/admin/templates/page'));
const AdminContentPage = lazy(() => import('../pages/admin/content/page'));
const AdminSupportPage = lazy(() => import('../pages/admin/support/page'));
const AdminAnalyticsPage = lazy(() => import('../pages/admin/analytics/page'));
const AdminSettingsPage = lazy(() => import('../pages/admin/settings/page'));
const AdminPlanSimulator = lazy(() => import('../pages/admin/plan-simulator/page'));
const PaymentSuccessPage = lazy(() => import('../pages/payment-success/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/pricing', element: <PricingPage /> },
  { path: '/login', element: <LoginPage /> },
  { path: '/signup', element: <SignupPage /> },
  { path: '/dashboard', element: <DashboardPage /> },
  { path: '/templates', element: <TemplatesPage /> },
  { path: '/payment-success', element: <PaymentSuccessPage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '/privacy', element: <PrivacyPage /> },
  { path: '/terms', element: <TermsPage /> },
  { path: '/admin/dashboard', element: <AdminDashboardPage /> },
  { path: '/admin/users', element: <AdminUsersPage /> },
  { path: '/admin/subscriptions', element: <AdminSubscriptionsPage /> },
  { path: '/admin/tools', element: <AdminToolsPage /> },
  { path: '/admin/ai-usage', element: <AdminAIUsagePage /> },
  { path: '/admin/conversions', element: <AdminConversionsPage /> },
  { path: '/admin/templates', element: <AdminTemplatesPage /> },
  { path: '/admin/content', element: <AdminContentPage /> },
  { path: '/admin/support', element: <AdminSupportPage /> },
  { path: '/admin/analytics', element: <AdminAnalyticsPage /> },
  { path: '/admin/settings', element: <AdminSettingsPage /> },
  { path: '/admin/plan-simulator', element: <AdminRoute><AdminPlanSimulator /></AdminRoute> },
  { path: '*', element: <NotFound /> },
];

export default routes;
